<template>
    <v-container fluid>
        <v-layout row justify-end fill-height>
            <v-flex xs4 sm3 md2 class="dl_button_flex">
                <v-btn v-if="report_button" class="success dl_button">
                    <v-icon left>cloud_download</v-icon>                 
                    <download-csv
                        :data="csvReportData"
                        :fields="getReportFields"
                        :labels="report_labels"
                        :name="report_name"
                    >
                        Download As CSV
                    </download-csv>
                    
                </v-btn>
            </v-flex>
        </v-layout>
        <br>
        <v-layout row fill-height>            
            <v-flex >
                <SortableDataTable
                    ref="advert-vuetable"
                    :header-fields="obtainTableFields()"
                    :data="sortedData || []"
                    :totals-row="totalsRow"
                    :sort-field="currentSortField"
                    :sort="currentSortDir"
                    @on-update="updateSort"
                    not-found-msg="No data available"
                >
                </SortableDataTable>
            </v-flex>
        </v-layout>
        <br>
        <v-layout 
            row 
            justify-end 
            fill-height
            v-if="processedData.length && processedData.length >= 20"
        >
            <v-flex xs4 sm3 md2 class="dl_button_flex">
                <v-btn v-if="report_button" class="success dl_button">
                    <v-icon left>cloud_download</v-icon>                 
                    <download-csv
                        :data="csvReportData"
                        :fields="getReportFields"
                        :labels="report_labels"
                        :name="report_name"
                    >
                        Download As CSV
                    </download-csv>
                    
                </v-btn>
            </v-flex>
        </v-layout>
        <v-fab-transition>
            <v-btn
                md-3 mr-5
                dark
                fab
                fixed
                right
                bottom
                color="purple"
                @click="toTop"
                v-if="sortedData.length > 20"
            >
                <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
        </v-fab-transition>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import SortableDataTable from './SortableDataTable.vue';

export default {
    name: 'AdvertDataTable',
    components: {
        SortableDataTable
    },
    props: {
        rows: { type: Array, required: true },
        timeframe: { type: String, required: true },
        campaign: { type: String, required: true },
        os: { type: String, required: true },
        osOptions: {type: Array, required: true},
        dateFrom: {required: true},
        dateTo: {required: true},
        groupByCampaign: {required: true},
        groupByOS: {required: true},
    },
    data() {
        return {
            report_button: false,
            default_fields: [
                {
                    name:'date',
                    label:'Date',
                    sortable: true
                },
                {
                    name:'campaign_name',
                    label:'Campaign',
                    sortable: true,
                    visible: false,
                    defaultSorting: 'asc'
                },
                {
                    name:'os_name',
                    label:'OS',
                    sortable: true,
                    visible: false,
                    defaultSorting: 'asc'
                },
                {
                    name:'impressions',
                    label:'Impressions',
                    sortable: true,
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                {
                    name:'clicks',
                    label:'Clicks',
                    sortable: true,
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                {
                    name:'conversions',
                    label:'Conversions',
                    sortable: true,
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                    
                },
                {
                    name:'advertiser_spent',
                    label:'Spend ($)',
                    sortable: true,
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                    
                },
                {
                    name:'transaction_value',
                    label:'Transaction Value ($)',
                    sortable: true,
                    format: value => value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
                    visible: true,
                },
                {
                    name:'ecpa',
                    label:'eCPA ($)',
                    sortable: true,
                },
                {
                    name:'roi',
                    label:'ROI (%)',
                    visible: true,
                    sortable: true,
                },
            ],
            report_name: "DataReport_" + new Date().toISOString().substr(0, 10) + ".csv",
            report_labels: {
                date: 'Date',
                campaign_name: 'Campaign Name',
                os_name: 'OS',
                impressions: 'Impressions',
                clicks: 'Clicks',
                conversions: 'Conversions',
                advertiser_spent: 'Spend ($)',
                transaction_value: 'Transaction Value ($)',
                ecpa: 'eCPA ($)',
                roi: 'ROI (%)'
            },
            report_default_fields: [
                'impressions', 'clicks', 'conversions', 'advertiser_spent', 'transaction_value', 'ecpa', 'roi'
            ],
            totalsRow: {},
            currentSortDir: 'desc',
            currentSortField: 'date',
        }
    },
    computed: {
        ...mapGetters([
            'activeUser',
            'getUserCampaigns'
        ]),
        mappedCampaigns() {
            let mappings = {}
            console.dir(this.getUserCampaigns)
            if (this.getUserCampaigns.length) {
                this.getUserCampaigns.map(campaign => {
                    if (campaign.name) {
                        mappings[campaign.external_id] = campaign.name
                    }
                })
            }            
            return mappings
        },
        // backend API data transformed and filtered by selected input values: timeframe, campaign, os
        processedData() {
            if (this.rows.length) {
                let mapped_campaigns = this.mappedCampaigns
                const mapped_os = {}
                this.osOptions.map(os_obj => {
                    mapped_os[os_obj.value] = os_obj.title
                })
                this.report_button = true
                // let rows_copy = JSON.parse(JSON.stringify(this.rows)).slice()
                let rows_copy = Array.from(this.rows)
                // pop last element with summary data
                let last_element = rows_copy.pop()
                
                // filter data by selected timeframe
                rows_copy = this.filterByDateOption(rows_copy)

                if (!rows_copy.length) {
                    this.totalsRow = this.summaryRow(rows_copy)
                    return []
                }

                rows_copy = rows_copy.filter(row => {
                    return row.advertiser_id === this.activeUser.advertiser_id
                })

                // filter data by selected campaign
                if (this.campaign !== '0') {
                    rows_copy = rows_copy.filter(row => {
                        return row.campaign_id === this.campaign
                    })

                    if (this.os === '0' && this.groupByOS) {
                        rows_copy = rows_copy.filter(row => {
                            return row.os_id
                        })
                    } else if (this.os === '0' && !this.groupByOS) {
                        rows_copy = rows_copy.filter(row => {
                            return !row.os_id
                        })
                    } else {
                        rows_copy = rows_copy.filter(row => {
                            return row.os_id === this.os
                        })
                    }      
                } else {
                    if (this.groupByCampaign) {
                        if (this.groupByOS && this.os === '0') {
                            rows_copy = rows_copy.filter(row => {
                                return row.os_id
                            })
                        } else if (!this.groupByOS && this.os === '0') {
                            rows_copy = rows_copy.filter(row => {
                                return row.campaign_id && !row.os_id
                            })
                        } else if (this.os !== '0') {
                            rows_copy = rows_copy.filter(row => {
                                return row.campaign_id && row.os_id === this.os
                            })
                        }
                    } else {
                        rows_copy = rows_copy.filter(row => {
                            return !row.campaign_id && !row.os_id
                        })
                    }
                }

                if (!rows_copy.length) {
                    this.totalsRow = this.summaryRow(rows_copy)
                    return []
                }

                let out_rows = rows_copy.map(obj => {
                    if (this.groupByCampaign && obj.campaign_id) {
                        obj.campaign_name = mapped_campaigns[obj.campaign_id] ? mapped_campaigns[obj.campaign_id] : `N/A (id: ${obj.campaign_id})`
                    }
                    if (this.groupByOS && obj.os_id){
                        obj.os_name = mapped_os[obj.os_id] ? mapped_os[obj.os_id] : `N/A (id: ${obj.os_id})`
                    }

                    if (!obj.advertiser_spent) {
                        obj.advertiser_spent = 0
                    }

                    if (!obj.conversions) {
                        obj.conversions = 0
                    }
                    if (obj.conversions != 0) {
                        obj.ecpa = Number(obj.advertiser_spent / obj.conversions).toFixed(2)
                    } else {
                        obj.ecpa = '0.00'
                    }

                    if (!obj.transaction_value) {
                        obj.transaction_value = 0
                    } else {
                        obj.transaction_value = Number(obj.transaction_value).toFixed(2)
                    }
                    
                    if (obj.advertiser_spent) {
                        obj.advertiser_spent = Number(obj.advertiser_spent).toFixed(2)
                        obj.roi = Number((obj.transaction_value / obj.advertiser_spent)*100).toFixed(1)
                    } else {
                        obj.roi = '0.0'
                    }
                    
                    return obj
                })

                let sorted_rows = out_rows.sort(
                    (a,b) => new Date(a.date).getTime() - new Date(b.date).getTime()
                )

                this.totalsRow = this.summaryRow(sorted_rows)

                return sorted_rows
            } else {
                this.totalsRow = this.summaryRow([])
                return []
            }
            
        },
        // processed data sorted by selected filter (field, asc, desc)
        sortedData() {
            let toSort = Array.from(this.processedData)
            return toSort.sort((a, b) => {
                let modifier = 1
                if (this.currentSortDir === 'desc') {
                    modifier = -1
                }
                // if (this.currentSortField === 'date') {
                if (['date', 'campaign_name', 'os_name'].includes(this.currentSortField)) {
                    if (a[this.currentSortField] < b[this.currentSortField]) {
                        return -1 * modifier
                    }
                    if (a[this.currentSortField] > b[this.currentSortField]) {
                        return modifier
                    }
                    
                } else {
                    if (Number(a[this.currentSortField]) < Number(b[this.currentSortField])) {
                        return -1 * modifier
                    }
                    if (Number(a[this.currentSortField]) > Number(b[this.currentSortField])) {
                        return modifier
                    }
                }
                return 0
            })
        },
        // data for csv report
        csvReportData() {
            // let data = JSON.parse(JSON.stringify(this.sortedData))
            let data = Array.from(this.sortedData)
            data.push(this.totalsRow)
            return data
        },
        tableFields() {
            /* property to select table headers depending on the row object,
                disable excluded headers 
                
                all campaigns + group by - show campaign column
                all os + group by - show os column
                group by campaign + group by os - show both

            */

            let fields_to_disable = []
            if (!this.groupByCampaign) {
                fields_to_disable.push('campaign_name')
            }
            if (!this.groupByOS) {
                fields_to_disable.push('os_name')
            }
            console.log(fields_to_disable)
            let out_headers = this.default_fields.map(field_obj => {
                if (fields_to_disable.includes(field_obj.name)){
                    field_obj.visible = false
                } else {
                    field_obj.visible = true
                }
                return field_obj
            })

            out_headers = out_headers.filter(field_obj => field_obj.visible)
            // console.dir(out_headers)

            return out_headers
        },

        getReportFields() {
            // compose headers for a CSV report
            let out_fields = [...this.report_default_fields]
            let table_fields = this.tableFields.map(field_obj => field_obj.name)
            if (table_fields.includes('os_name')){
                out_fields.unshift('os_name')
            }
            if (table_fields.includes('campaign_name')){
                out_fields.unshift('campaign_name')
            }
            if (table_fields.includes('date')){
                out_fields.unshift('date')
            }
            return out_fields
        },
    },
    methods: {
        // calculate totals row for the datatable
        summaryRow(rows) {
            if (rows.length) {
                let out_obj = {
                    date: "Total",
                }

                out_obj.clicks = rows.reduce((total, row) => {
                    return total + Number(row.clicks)
                }, 0)
                out_obj.impressions = rows.reduce((total, row) => {
                    return total + Number(row.impressions)
                }, 0)
                out_obj.conversions = rows.reduce((total, row) => {
                    return total + Number(row.conversions)
                }, 0)
                out_obj.advertiser_spent = rows.reduce((total, row) => {
                    return total + Number(row.advertiser_spent)
                }, 0)

                if (out_obj.advertiser_spent != 0) {
                    out_obj.advertiser_spent = Number(out_obj.advertiser_spent).toFixed(2)
                }
                out_obj.transaction_value = rows.reduce((total, row) => {
                    return total + Number(row.transaction_value)
                }, 0)

                if (out_obj.transaction_value != 0) {
                    out_obj.transaction_value = Number(out_obj.transaction_value).toFixed(2)
                } else {
                    out_obj.transaction_value = '0.00'
                }

                if (out_obj.conversions != 0) {
                    out_obj.ecpa = Number(out_obj.advertiser_spent / out_obj.conversions).toFixed(2)
                } else {
                    out_obj.ecpa = '0.00'
                }
                
                if (out_obj.advertiser_spent) {
                    out_obj.roi = Number((out_obj.transaction_value / out_obj.advertiser_spent)*100).toFixed(1)
                } else {
                    out_obj.roi = '0.0'
                }
                return out_obj

            } else {
                return {
                    date: "Total",
                    impressions: 0,
                    clicks: 0,
                    conversions: 0,
                    advertiser_spent: '0.00',
                    transaction_value: '0.00',
                    ecpa: '0.00',
                    roi: '0.0',
                }
            }
        },
        sumRowsByDate(rows) {
            if (rows.length) {
                let result_rows = []
                let dates = []

                rows.forEach(row => {
                    let date_index = dates.indexOf(row.date)
                    if (date_index == -1) {
                        dates.push(row.date)
                        let initial_obj = {
                            date: row.date,
                            clicks: Number(row.clicks),
                            impressions: Number(row.impressions),
                            conversions: Number(row.conversions),
                            advertiser_spent: Number(row.advertiser_spent),
                            transaction_value: Number(row.transaction_value)                        
                            }
                        result_rows.push(initial_obj)
                    } else {
                        let existing_obj = result_rows[date_index]
                        existing_obj.clicks += Number(row.clicks)
                        existing_obj.impressions += Number(row.impressions)
                        existing_obj.conversions += Number(row.conversions)
                        existing_obj.advertiser_spent += Number(row.advertiser_spent)
                        existing_obj.transaction_value += Number(row.transaction_value)
                    }
                })
                return result_rows

            } else {
                return []
            }
        },
        // filter API data by selected timeframe input
        filterByDateOption(rows) {
            if (this.timeframe === 'mtd') {
                let currentMonth = new Date().getMonth() + 1
                rows = rows.filter(row => {
                    let month = row.date.split('-')[1]
                    return (currentMonth === +month)
                })
            } else if (this.timeframe === 'lastmonth') {
                // let lastMonth = new Date().getMonth()
                // The summary API endpoint returns data for 2 months - current and previous
                // Change the filtering logic if the range will be extended
                let currentMonth = new Date().getMonth() + 1
                rows = rows.filter(row => {
                    let month = row.date.split('-')[1]
                    return (currentMonth !== +month)
                })
            } else if (this.timeframe === '30days') {
                let yesterday = new Date(new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10))
                let yesterday_utc = Date.UTC(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate())
                
                rows = rows.filter(row => {
                    let row_date = new Date(new Date(row.date).toISOString().substr(0, 10))                    
                    let row_date_utc = Date.UTC(row_date.getFullYear(), row_date.getMonth(), row_date.getDate())
                    let days_delta = Math.ceil(Math.abs(yesterday_utc - row_date_utc) / (1000 * 60 * 60 * 24))

                    return days_delta < 30
                })
            } else if (this.timeframe === '7days') {
                let yesterday = new Date(new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10))
                let yesterday_utc = Date.UTC(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate())
                
                rows = rows.filter(row => {
                    let row_date = new Date(new Date(row.date).toISOString().substr(0, 10))                    
                    let row_date_utc = Date.UTC(row_date.getFullYear(), row_date.getMonth(), row_date.getDate())
                    let days_delta = Math.ceil(Math.abs(yesterday_utc - row_date_utc) / (1000 * 60 * 60 * 24))

                    return days_delta < 7
                })
            } else if (this.timeframe === 'yesterday') {
                let yesterday = new Date(new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10))
                let yesterday_utc = Date.UTC(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate())
                
                rows = rows.filter(row => {
                    let row_date = new Date(new Date(row.date).toISOString().substr(0, 10))                    
                    let row_date_utc = Date.UTC(row_date.getFullYear(), row_date.getMonth(), row_date.getDate())

                    return row_date_utc === yesterday_utc
                })
            } else if (this.timeframe === 'custom') {
                let from_date = new Date(new Date(this.dateFrom).toISOString().substr(0, 10))
                let to_date = new Date(new Date(this.dateTo).toISOString().substr(0, 10))

                rows = rows.filter(row => {
                    let row_date = new Date(new Date(row.date).toISOString().substr(0, 10))
                    return row_date >= from_date && row_date <= to_date
                })
            }
            return rows
        },
        obtainTableFields() {
            return this.tableFields
        },
        // scroll to top
        toTop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        },
        updateSort({ sortField, sort }) {
            if (sortField === this.currentSortField) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
            } else {
                this.currentSortDir = sort
            }
            this.currentSortField = sortField
        },
    }
}
</script>

<style>
table.v-datatable-light tfoot tr:last-child {
    /* background: #b9cbe8; */
    font-weight: bold;
}

table.v-datatable-light thead tr th,
table.v-datatable-light tbody tr td,
table.v-datatable-light tfoot tr th {
    text-align:center;
}

table.v-datatable-light thead tr th:first-child,
table.v-datatable-light tbody tr td:first-child,
table.v-datatable-light tfoot tr th:first-child {
    text-align: left;
    padding-left: 1.2em;
}

table.v-datatable-light thead tr th:last-child,
table.v-datatable-light tbody tr td:last-child,
table.v-datatable-light tfoot tr th:last-child {
    text-align: right;
    padding-right: 1.2em;
}

.dl_button_flex {
    direction:rtl;
}

.dl_button {
    direction: ltr;
}
</style>
